module.exports = __webpack_public_path__ + "img/841.5eec2a4f.svg";